import { useToast } from "vue-toastification";
import { getDeviceInfo } from "@/helpers/helper";
import axios from "axios";
import router from "@/router";

const toast = useToast();

export const resolveUrl = (origin) => {
  switch (origin) {
    case "http://localhost:5173":
    case "http://localhost:5174":
    case "http://localhost:5175":
      return "http://localhost:8000/api/v1/";
    case "https://kyc.demulla.co.ke":
      return "https://core.kyc.demulla.co.ke/api/v1/";
    case "https://staging.kyc.demulla.co.ke":
      return "https://stagingkyc.api.demulla.co.ke/api/v1/";
    case "https://dev.kyc.demulla.co.ke":
      return "https://devkyc.api.demulla.co.ke/api/v1/";
    default:
      return "https://core.kyc.demulla.co.ke/api/v1/";
  }
};

const BASE_URL = import.meta.env.VITE_API_BASE_URL || resolveUrl(window.location.origin);

let toastShown = false;

const session = {
  user: null,
  permissions: [],
  roles: [],
  modules: [],
};

export const setSession = (data = {}) => {
  session.user = data.user ?? null;
  session.permissions = Array.isArray(data.permissions) ? data.permissions : [];
  session.roles = Array.isArray(data.roles) ? data.roles : [];
  session.modules = Array.isArray(data.modules) ? data.modules : [];
};

export const clearSession = () => {
  session.user = null;
  session.permissions = [];
  session.roles = [];
  session.modules = [];
};

export const getSession = () => session;

const http = () => {
  const apiClient = axios.create({
    baseURL: BASE_URL,
    withCredentials: false,
    validateStatus: (status) => status >= 200 && status < 300,
  });

  apiClient.interceptors.request.use((config) => {
    const token = localStorage.getItem("kyc_token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    config.headers["X-Device-Info"] = JSON.stringify(getDeviceInfo());
    config.headers["Accept"] = "application/json";
    return config;
  });

  apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        clearSession();
        localStorage.removeItem("kyc_token");
        localStorage.removeItem("kyc_user");
        localStorage.removeItem("user_permissions");
        localStorage.removeItem("user_role");
        localStorage.removeItem("modules");

        if (!toastShown) {
          toast.error("Your session has expired. Please log in again.");
          toastShown = true;
          setTimeout(() => { toastShown = false; }, 5000);
        }

        router.push({ name: "auth.sign-in" });
      }
      return Promise.reject(error);
    },
  );

  return apiClient;
};


export default http;
